"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
// CalendarNavigationStyles.ts
const css_in_js_1 = require("../../components/css-in-js");
exports.styles = {
    calendarNavigation: (0, css_in_js_1.css) `
        padding: 6px 8px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
    actionButtonCopy: (0, css_in_js_1.css) `
        border-radius: 0px;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        border-right: none;
    `,
    actionButtonDownload: (0, css_in_js_1.css) `
        border-radius: 0px;
    `,
    actionButtonDelete: (0, css_in_js_1.css) `
        border-radius: 0px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        border-left: none;
    `,
};
//# sourceMappingURL=CalendarNavigationStyles.js.map